// extracted by mini-css-extract-plugin
export var hideEditor = "_ik-2";
export var infoIcon = "_ik-3";
export var label = "_ik-1";
export var labelContainer = "_ik-0";
export var readonlyText = "_ik-4";